<template>
  <span class="text-barlow-condensed subtitle d-flex legend-container mx-auto">
    <div class="correct"></div>
    <span class="mx-2">Correctas</span>
    <div class="incorrect"></div>
    <span class="mx-2">Incorrectas</span>
    <template v-if="notAnswered">
      <div class="notAnswer"></div>
      <span class="mx-2"> No contestadas</span>
    </template>
  </span>
</template>

<script>
export default {
  name: "Legend",
  props: {
    notAnswered: {
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-container {
  width: 350px;
}

.legend-container div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.correct {
  background: var(--color-secondary);
}

.incorrect {
  background: var(--color-primary);
}

.notAnswer {
  background: var(--color-blue);
}
</style>
